var map = {
	"./5g-area.png": "6ead",
	"./ICCA.png": "98d0",
	"./KEC-inside-blued.png": "c5de",
	"./Robert.jpg": "76d9",
	"./UFI_Member-logo-06AB23A13E-seeklogo.com.png": "9dda",
	"./btn1-370x300.jpg": "7dbc",
	"./btn2-415x300.jpg": "0bb6",
	"./btn3-415x300.jpg": "df4d",
	"./btn4-370x300.jpg": "8f59",
	"./cybersecurity-img-1.jpg": "69cd",
	"./cybersecurity-img-2.jpg": "d11a",
	"./cybersecurity-img-3.jpg": "aa8f",
	"./cybersecurity-img-4.jpg": "51e4",
	"./footer-5g.png": "0679",
	"./footer-backend.png": "9df3",
	"./footer.jpg": "7e7f",
	"./ic.png": "b044",
	"./icon1.png": "3197",
	"./icon2.png": "1705",
	"./icon3.png": "fb39",
	"./icon4.png": "993d",
	"./intex-banner.jpg": "9584",
	"./kec-slider1.png": "0147",
	"./layout-v1.jpg": "158f",
	"./logo-hakuodo.png": "9568",
	"./logo-interplan.png": "49c8",
	"./logo-list-1.png": "4e0f",
	"./logo-list-2.png": "f945",
	"./logo-list-3.png": "9de2",
	"./logo-list-4.png": "6a4c",
	"./logo-list-5.png": "1032",
	"./logo-list-6.png": "ff30",
	"./logo_DOIT.png": "4ef0",
	"./logo_III.png": "c862",
	"./no-picture-2-new.jpg": "ed5b",
	"./no-picture-new.jpg": "ccb7",
	"./pageBanner-ConnectUs.jpg": "046c",
	"./pageBanner-DocumentDownload.jpg": "6404",
	"./pageBanner-JoinUs.jpg": "e4e5",
	"./pageBanner-aboutKH.jpg": "c028",
	"./pageBanner-activities.jpg": "069e",
	"./pageBanner-activityExtension.jpg": "6c9f",
	"./pageBanner-bookingInquiry.jpg": "156e",
	"./pageBanner-facilitiesService.jpg": "0deb",
	"./pageBanner-latestNews.jpg": "e7d7",
	"./pageBanner-meetOurTeam.jpg": "37df",
	"./pageBanner-trafficInformation.jpg": "f721",
	"./pageBanner-wonderfulExample.jpg": "e55b",
	"./partner_logo1.png": "ed17",
	"./partner_logo2.png": "7756",
	"./partner_logo3.png": "c5f4",
	"./partner_logo4.png": "9ec2",
	"./partner_logo5.png": "818f",
	"./partner_logo6.png": "e478",
	"./pic-joinus.png": "8fdd",
	"./pic-meet.jpg": "1e2d",
	"./pic-other.jpg": "dba7",
	"./pic-other2.jpg": "5e9b",
	"./pic-paging-aiot-1.jpg": "7f71",
	"./pic-paging-aiot-2.jpg": "e7e3",
	"./pic-paging-aiot-3.jpg": "1096",
	"./pic-paging-aiot-4.jpg": "60ad",
	"./pic-paging-faq-1.jpg": "a878",
	"./pic-paging-faq-2.jpg": "dc08",
	"./pic-paging-faq-3.jpg": "7645",
	"./pic-paging-faq-4.jpg": "c3e3",
	"./pic-paging-service-1.jpg": "a6f0",
	"./pic-paging-service-2-1.jpg": "d8bd",
	"./pic-paging-service-2-2.jpg": "4fc0",
	"./pic-paging-service-2.jpg": "ea80",
	"./pic-paging-service-3-1.jpg": "ec26",
	"./pic-paging-service-3-2.jpg": "b907",
	"./pic-paging-service-3.jpg": "a2fd",
	"./pic-paging-service1-1.jpg": "a49e",
	"./pic-paging-service1-2.jpg": "40b1",
	"./pic-paging-service4-1.jpg": "24ff",
	"./pic-paging-service4-2.jpg": "5f02",
	"./pic-trafficInfo.jpg": "2ac6",
	"./seawave-bg.png": "d144",
	"./subscribe.jpg": "974f",
	"./teca-logo.png": "ac62",
	"./余美慧.jpg": "5888",
	"./杜秋菁.jpg": "04c0",
	"./林素琴.jpg": "e8ea",
	"./涂宇欣.jpg": "2322",
	"./涂建國.jpg": "c6b3",
	"./許力文.jpg": "9b83",
	"./郭天羿.jpg": "88ea",
	"./鄭順安.jpg": "ce33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a03b";